import type { AppData } from '../types';
import { makeDateFrom } from '../utils/dates';

const d1O = new Date();
d1O.setDate(d1O.getDate() - 26);
const d2O = new Date();
d2O.setDate(d2O.getDate() - 9);

export const DEMO: AppData = {
  dossiers: [
    {
      id: 'd1',
      ref: '2024-001',
      client: 'Dupont Martin',
      type: 'Civil',
      statut: 'En cours',
      desc: 'Litige locatif — impayés de loyer',
      honoraires: 1500,
      ouverture: d1O.toISOString().split('T')[0],
      modeFacturation: 'horaire',
      tauxHoraire: 180,
      statutPaiement: 'Acompte versé',
      montantRegle: 500,
    },
    {
      id: 'd2',
      ref: '2024-002',
      client: 'SARL Leblanc',
      type: 'Commercial',
      statut: 'En cours',
      desc: 'Recouvrement de créance 45 000€',
      honoraires: 3200,
      ouverture: d2O.toISOString().split('T')[0],
      modeFacturation: 'horaire',
      tauxHoraire: 200,
      statutPaiement: 'En attente',
      montantRegle: 0,
    },
    {
      id: 'd3',
      ref: '2024-003',
      client: 'Fontaine Sophie',
      type: 'Famille',
      statut: 'En attente',
      desc: 'Procédure de divorce contentieux',
      honoraires: 2800,
      ouverture: makeDateFrom(0),
      modeFacturation: 'forfait',
      tauxHoraire: 0,
      statutPaiement: 'Partiellement réglé',
      montantRegle: 1200,
    },
  ],
  delais: [
    {
      id: 'e1',
      dossier: 'd1',
      titre: 'Dépôt conclusions récapitulatives',
      date: makeDateFrom(1),
      type: 'Procédure',
    },
    {
      id: 'e2',
      dossier: 'd2',
      titre: 'Audience au TGI',
      date: makeDateFrom(5),
      type: 'Audience',
    },
    {
      id: 'e3',
      dossier: 'd1',
      titre: 'Réponse adverse',
      date: makeDateFrom(12),
      type: 'Procédure',
    },
    {
      id: 'e4',
      dossier: 'd3',
      titre: 'Envoi assignation',
      date: makeDateFrom(28),
      type: 'Acte',
    },
  ],
  taches: [
    {
      id: 't1',
      dossier: 'd1',
      titre: 'Relancer le client pour pièces manquantes',
      fait: false,
      priorite: 'Haute',
      date: makeDateFrom(0),
    },
    {
      id: 't2',
      dossier: 'd1',
      titre: 'Rédiger conclusions',
      fait: false,
      priorite: 'Haute',
      date: makeDateFrom(1),
    },
    {
      id: 't3',
      dossier: 'd2',
      titre: 'Vérifier extrait Kbis',
      fait: true,
      priorite: 'Normale',
      date: makeDateFrom(-2),
    },
    {
      id: 't4',
      dossier: 'd3',
      titre: 'Préparer inventaire patrimoine',
      fait: false,
      priorite: 'Normale',
      date: makeDateFrom(3),
    },
  ],
  temps: [
    {
      id: 'tm1',
      dossier: 'd1',
      desc: 'Recherches jurisprudence',
      type: 'horaire',
      mins: 90,
      montant: null,
      date: makeDateFrom(-3),
      facture: false,
    },
    {
      id: 'tm2',
      dossier: 'd2',
      desc: 'Entretien client',
      type: 'horaire',
      mins: 60,
      montant: null,
      date: makeDateFrom(-1),
      facture: true,
    },
    {
      id: 'tm3',
      dossier: 'd3',
      desc: "Convention d'honoraires",
      type: 'forfait',
      mins: null,
      montant: 2500,
      date: makeDateFrom(-5),
      facture: false,
    },
  ],
  notes: [
    {
      id: 'n1',
      dossier: 'd1',
      contenu: 'Client à rappeler avant le 20. Conteste le montant des charges.',
      date: makeDateFrom(-5),
    },
    {
      id: 'n2',
      dossier: 'd3',
      contenu: "Inventaire patrimonial incomplet. Épouse refuse de communiquer ses relevés.",
      date: makeDateFrom(-9),
    },
  ],
  contacts: [
    {
      id: 'c1',
      dossier: 'd1',
      nom: 'Me Arnaud Tessier',
      role: 'Avocat adverse',
      tel: '03 20 11 22 33',
      email: 'tessier@barreau-lille.fr',
      note: '',
    },
    {
      id: 'c2',
      dossier: 'd2',
      nom: 'Tribunal de commerce de Lille',
      role: 'Juridiction',
      tel: '03 20 00 01 02',
      email: 'tc-lille@justice.fr',
      note: 'Chambre 3',
    },
  ],
  journal: [
    {
      id: 'j1',
      dossier: 'd1',
      action: 'Dossier ouvert',
      detail: 'Dupont Martin — Civil',
      ts: d1O.toISOString(),
    },
    {
      id: 'j2',
      dossier: 'd1',
      action: 'Note ajoutée',
      detail: 'Client à rappeler avant le 20...',
      ts: new Date(Date.now() - 5 * 86400000).toISOString(),
    },
    {
      id: 'j3',
      dossier: 'd2',
      action: 'Temps enregistré',
      detail: 'Entretien client — 1h',
      ts: new Date(Date.now() - 86400000).toISOString(),
    },
  ],
  factures: [
    {
      id: 'f1',
      dossier: 'd1',
      numero: 'F2024-0001',
      montant: 1500,
      date: makeDateFrom(-10),
      statut: 'Acompte versé',
    },
    {
      id: 'f2',
      dossier: 'd2',
      numero: 'F2024-0002',
      montant: 3200,
      date: makeDateFrom(-3),
      statut: 'En attente',
    },
    {
      id: 'f3',
      dossier: 'd3',
      numero: 'F2024-0003',
      montant: 2800,
      date: makeDateFrom(-15),
      statut: 'Partiellement réglé',
    },
  ],
  courriers: [
    {
      id: 'cr1',
      dossier: 'd1',
      titre: 'Mise en demeure — Impayés loyers',
      contenu: 'Monsieur,\n\nPar la présente, nous vous mettons en demeure de vous acquitter de la somme de 12 000€ correspondant à vos impayés de loyer...',
      date: makeDateFrom(-8),
      type: 'Mise en demeure',
      statut: 'Envoyé',
      destinataire: 'Dupont Martin',
    },
    {
      id: 'cr2',
      dossier: 'd2',
      titre: 'Notification assignation',
      contenu: 'À l\'attention du tribunal de commerce...',
      date: makeDateFrom(-2),
      type: 'Assignation',
      statut: 'Signé',
      destinataire: 'Tribunal de commerce de Lille',
    },
    {
      id: 'cr3',
      dossier: 'd3',
      titre: 'Demande de pièces',
      contenu: 'Madame,\n\nEn vue de poursuivre le dossier de divorce, nous vous demandons de nous fournir les pièces suivantes...',
      date: makeDateFrom(-1),
      type: 'Lettre',
      statut: 'Brouillon',
      destinataire: 'Fontaine Sophie',
    },
  ],
  avocat: {
    nom: 'Me Avocat',
    barreau: 'Barreau de Paris',
    adresse: '123 rue de la Paix, 75000 Paris',
    tel: '+33 1 23 45 67 89',
    email: 'contact@avocat.fr',
    siret: '12345678901234',
  },
};
